import { EnvironmentsEnum } from "@/types";

export * from "./sharedConfig";

export const contractAddress =
  "erd1qqqqqqqqqqqqqpgqtmcuh307t6kky677ernjj9ulk64zq74w9l5qxyhdn7";
export const API_URL = "https://api.multiversx.com";
export const AGENTS_API_URL =
  "https://ai-agents-service-142973565333.europe-west1.run.app";
export const sampleAuthenticatedDomains = [API_URL];
export const environment = EnvironmentsEnum.mainnet;

export const AI_NEXUS_API_URL =
  "https://europe-west1-ai-nexus-prod.cloudfunctions.net";